import React from 'react';
import PropTypes from 'prop-types';
import { PrintSize } from '../../../prop-types';
import { WebUI, builderDispatch } from '../../../../_utils/ui';
import fireTrackingEvent from '../../../common/events/fire-tracking-event';
import { UpdatePhotoEvents } from '../../../common/events/event-declarations';
import canOpenAdvancedEditor from '../../../common/can-open-advanced-editor';

const handleEdit = (photo, onAdvancedEdit) => {
  fireTrackingEvent(WebUI.PHOTO_EVENT_ADVANCED_EDIT);
  onAdvancedEdit(photo.client_uuid);
};

const handleRemove = (photo) => {
  builderDispatch.dispatch({
    type: UpdatePhotoEvents.REMOVE,
    clientUuid: photo.client_uuid,
  });
};

const handleRemoveByRootId = (clientUuid) => {
  builderDispatch.dispatch({
    type: UpdatePhotoEvents.SHOW_REMOVE_CONFIRMATION,
    clientUuid,
    useRoot: true,
  });
};

export default function EditablePhotoButtons({
  photo,
  isLastPhoto,
  onAdvancedEdit,
}) {
  return (
    <div className="photo-editable__buttons d-flex justify-content-between">
      <button
        aria-label={`Edit ${photo.filename} ${photo.size.title}`}
        className="btn btn-link btn-underline pl-0"
        disabled={!canOpenAdvancedEditor(photo)}
        title={`Edit ${photo.filename} ${photo.size.title}`}
        role="link"
        type="button"
        onClick={() => handleEdit(photo, onAdvancedEdit)}>
        Edit
      </button>
      <button
        aria-label={`Remove ${photo.filename} ${photo.size.title}`}
        className="btn btn-link btn-underline pr-0"
        title={`Remove ${photo.filename} ${photo.size.title}`}
        role="link"
        type="button"
        onClick={() =>
          isLastPhoto
            ? handleRemoveByRootId(photo.client_uuid)
            : handleRemove(photo)
        }>
        Remove
      </button>
    </div>
  );
}

EditablePhotoButtons.propTypes = {
  photo: PrintSize,
  isLastPhoto: PropTypes.bool,
  onAdvancedEdit: PropTypes.func,
};
